<app-bringoz-data-table [uniqueId]="tableUniqueId"
                       [defaultWidths]="defaultWidths"
                       [items]="visitConfigurations"
                       [rowHeight]="rowHeight"
                       [resizable]="true"
                       [isLoading]="isLoading"
                       (fetchNext)="fetchNextEvent.emit()">

  <ng-template tableHeader>
    <!-- col-id is pinned left by TableColumnManager - renaming it unpins the checkbox column. -->
    <div class="th col-id"></div>
    <div *ngIf="showAccountColumn" class="th col-account text-ellipsis">{{ 'Account' | translate }}</div>
    <div class="th col-projection text-ellipsis">{{ 'Projection' | translate }}</div>
    <div class="th col-skills text-ellipsis">{{ 'Skills' | translate }}</div>
    <div class="th col-destination text-ellipsis">{{ 'Destination' | translate }}</div>
    <div class="th col-frequency text-ellipsis">{{ 'Frequency' | translate }}</div>
    <div class="th col-time-window text-ellipsis">{{ 'Time Window' | translate }}</div>
    <div class="th col-start text-ellipsis">{{ 'Start' | translate }}</div>
    <div class="th col-expiration text-ellipsis">{{ 'Expiration' | translate }}</div>
    <div class="th col-created-on text-ellipsis">{{ 'Created On' | translate }}</div>
    <div class="th col-updated-on text-ellipsis">{{ 'Updated On' | translate }}</div>
    <div class="th col-actions"></div>
  </ng-template>

  <ng-template tableRow let-visitConfiguration>
    <app-visit-configurations-table-row class="item"
                                       [showAccountColumn]="showAccountColumn"
                                       [visitConfiguration]="visitConfiguration"
                                       [isSelected]="selectedKeys[visitConfiguration.id]"
                                       (onToggle)="onToggleSelectVisitConfiguration(visitConfiguration.id, $event)"
                                       (onEdit)="onEdit.emit(visitConfiguration)"
                                       (onDelete)="onDelete.emit(visitConfiguration.id)">
    </app-visit-configurations-table-row>
  </ng-template>

  <app-empty-state tableEmptyState
                   src="assets/images/empty_state/empty_state_location_box.svg"
                   text="No projection templates found">
  </app-empty-state>

</app-bringoz-data-table>
